// Russian texts. The key is the English text the UI shows; {name} marks a value filled in at run time.
// Glossary: Drawings — Чертежи, References — Референсы, Photos — Фото, Steps — Шаги, Detections — Распознанное,
// Workspace — Редактор, Find models — Подобрать модели, Library — Библиотека, Assignee — Исполнитель.

// a noun with its forms for 1, 2–4 and 5 or more
export const nouns: Record<string, [string, string, string]> = {
    task: ['задача', 'задачи', 'задач'],
    reference: ['референс', 'референса', 'референсов'],
    drawing: ['чертёж', 'чертежа', 'чертежей'],
    photo: ['фото', 'фото', 'фото'],
    label: ['метка', 'метки', 'меток'],
    category: ['категория', 'категории', 'категорий'],
    detection: ['объект', 'объекта', 'объектов'],
    object: ['объект', 'объекта', 'объектов'],
    'object:of': ['объекта', 'объектов', 'объектов'],
    model: ['модель', 'модели', 'моделей'],
    image: ['изображение', 'изображения', 'изображений'],
    step: ['шаг', 'шага', 'шагов'],
    item: ['объект', 'объекта', 'объектов'],
    match: ['совпадение', 'совпадения', 'совпадений'],
};

export const strings: Record<string, string> = {
    // header and user menu
    Projects: 'Проекты',
    'Search projects': 'Поиск проектов',
    'Could not receive a list of organizations': 'Не удалось загрузить список организаций',
    'Server version:': 'Версия сервера:',
    'Core version:': 'Версия ядра:',
    'Canvas version:': 'Версия холста:',
    'UI version:': 'Версия интерфейса:',
    'Admin page': 'Администрирование',
    Organization: 'Организация',
    Settings: 'Настройки',
    Invitations: 'Приглашения',
    Create: 'Создать',
    'Select an organization': 'Выберите организацию',
    'Switch organization': 'Сменить организацию',
    'Personal workspace': 'Личное пространство',
    More: 'Ещё',
    Tasks: 'Задачи',
    References: 'Референсы',
    Jobs: 'Задачи по этапам',
    'Cloud storages': 'Облачные хранилища',
    Models: 'Модели',
    Analytics: 'Аналитика',
    About: 'О программе',
    'Change password': 'Сменить пароль',
    Logout: 'Выйти',
    'Press {key} to switch': 'Нажмите {key}, чтобы открыть',
    'Light theme': 'Светлая тема',
    'Dark theme': 'Тёмная тема',

    // Projects page
    'No project matches the search': 'Ничего не найдено',
    'No projects yet. Start with New project.': 'Проектов пока нет. Начните с кнопки «Новый проект».',
    'Projects matching “{search}”': 'Проекты по запросу «{search}»',
    'Import from backup': 'Импорт из резервной копии',
    'New project': 'Новый проект',
    'updated {ago}': 'обновлён {ago}',
    Continue: 'Продолжить',
    Drawings: 'Чертежи',
    Photos: 'Фото',

    // project actions
    'The project {id} will be deleted': 'Проект {id} будет удалён',
    'All related data (images, annotations) will be lost. Continue?':
        'Все данные проекта (изображения, разметка) будут потеряны. Продолжить?',
    Delete: 'Удалить',
    'Export dataset': 'Экспорт датасета',
    'Import dataset': 'Импорт датасета',
    'Backup Project': 'Резервная копия',
    'View analytics': 'Аналитика',
    'Setup webhooks': 'Вебхуки',

    // project page and its rows
    'There was something wrong during getting the project': 'Не удалось открыть проект',
    'Please, be sure, that information you tried to get exist and you are eligible to access it':
        'Проверьте, что проект существует и у вас есть к нему доступ',
    'The project was not found': 'Проект не найден',
    'Path copied': 'Путь скопирован',
    'Could not copy the path': 'Не удалось скопировать путь',
    'No tasks yet. Add drawings with New task.': 'Задач пока нет. Добавьте чертежи кнопкой «Новая задача».',
    'Copy path': 'Копировать путь',
    'No folder yet': 'Папка не выбрана',
    'Choose folder': 'Выбрать папку',
    'New task': 'Новая задача',
    'not linked to a task': 'не привязан к задаче',
    'Task #{id}': 'Задача №{id}',

    // New task dialog
    'Creating the task…': 'Создаём задачу…',
    'Adding the photos…': 'Добавляем фото…',
    'Task name': 'Название задачи',
    'A PDF or images of the floor plans': 'PDF или изображения планов',
    'References (optional)': 'Референсы (необязательно)',
    'Photos of the rooms': 'Фото помещений',
    'Drop files here or click to choose': 'Перетащите файлы сюда или нажмите, чтобы выбрать',
    'Give the task a name': 'Укажите название задачи',
    'Add at least one drawing': 'Добавьте хотя бы один чертёж',

    // project settings
    Renamed: 'Переименовано',
    'Folder changed': 'Папка изменена',
    'Delete the project “{name}”?': 'Удалить проект «{name}»?',
    'All its tasks, references and annotations are lost.': 'Все задачи, референсы и разметка проекта будут удалены.',
    General: 'Общие',
    Name: 'Название',
    'Shown on the Projects page and in the workspace': 'Видно на странице проектов и в редакторе',
    Rename: 'Переименовать',
    Folder: 'Папка',
    'Where the team keeps the drawings and photos': 'Где команда хранит чертежи и фото',
    Members: 'Участники',
    'Everyone in the organization can open the project': 'Проект может открыть любой участник организации',
    owner: 'владелец',
    'No owner': 'Без владельца',
    Annotation: 'Разметка',
    Processing: 'Обработка',
    'Which models run each step on new tasks': 'Какие модели выполняют шаги в новых задачах',
    'Models and defaults': 'Модели и настройки по умолчанию',
    Labels: 'Метки',
    'Labels saved': 'Метки сохранены',
    'Delete project': 'Удалить проект',
    'Removes its tasks, references and annotations': 'Удаляет задачи, референсы и разметку проекта',
    'Change folder': 'Сменить папку',
    Change: 'Изменить',
    'Hide editor': 'Скрыть редактор',
    'Edit labels': 'Изменить метки',

    // steps: titles and reasons come from the server in English
    'Align drawings': 'Выровнять чертежи',
    'Detect walls, doors and windows': 'Распознать стены, двери и окна',
    'Detect furniture': 'Распознать мебель',
    'Detect rooms': 'Распознать помещения',
    'Find furniture in library': 'Подобрать мебель из библиотеки',
    'Restore originals': 'Вернуть исходные',
    'Restore the original drawings?': 'Вернуть исходные чертежи?',
    'The drawings and their annotations go back to how they were before aligning.':
        'Чертежи и их разметка вернутся к виду до выравнивания.',
    Restore: 'Вернуть',
    'Could not restore the drawings': 'Не удалось вернуть чертежи',
    'Available when the processing finishes': 'Станет доступно, когда закончится обработка',
    'Align {n} drawings': 'Выровнять чертежи: {n}',
    'Aligning…': 'Выравниваем…',
    'Aligning… {done} of {total}': 'Выравниваем… {done} из {total}',
    'Could not align': 'Не удалось выровнять',
    'Try again': 'Повторить',
    'Replace {n} drawings': 'Заменить чертежи: {n}',
    Before: 'До',
    After: 'После',
    first: 'первый',
    waiting: 'ждёт',
    aligned: 'выровнен',
    'by hand': 'вручную',
    'aligned before': 'уже выровнен',
    'not aligned': 'не выровнен',
    'Adjust by hand': 'Подогнать вручную',
    'Aligning {name} by hand': 'Ручная подгонка: {name}',
    'Turn, °': 'Поворот, °',
    'Scale, %': 'Масштаб, %',
    'Align automatically': 'Выровнять автоматически',
    'Discard the alignment?': 'Отменить выравнивание?',
    'The drawings aligned by hand will have to be aligned again.':
        'Чертежи, подогнанные вручную, придётся подгонять заново.',
    Discard: 'Отменить',
    'Keep aligning': 'Продолжить',
    '{n} drawings could not be aligned automatically. Align them by hand, or replace the others and leave these as they are.':
        'Не удалось выровнять автоматически: {n}. Подгоните их вручную или замените остальные, а эти оставьте как есть.',
    'Replace the aligned drawings?': 'Заменить выровненные чертежи?',
    'Not aligned, these stay as they are: {names}. You can align them another time.':
        'Не выровнены и останутся как есть: {names}. Их можно выровнять позже.',
    'This drawing could not be aligned automatically': 'Этот чертёж не удалось выровнять автоматически',
    'There is nothing to align: the task has one drawing': 'Выравнивать нечего: в задаче один чертёж',
    'Where the colours meet, the lines match': 'Где цвета сливаются в тёмный, линии совпали',
    Controls: 'Управление',
    Wheel: 'Колёсико',
    Drag: 'Перетаскивание',
    'Double click': 'Двойной клик',
    Space: 'Пробел',
    Arrows: 'Стрелки',
    'Zoom in or out': 'Приблизить или отдалить',
    'Move the view': 'Сдвинуть вид',
    'Fit the drawing': 'Вписать чертёж',
    'Previous or next drawing': 'Предыдущий или следующий чертёж',
    'Before or after': 'До или после',
    'Move the drawing': 'Сдвинуть чертёж',
    'Scale the drawing, with Shift finer': 'Масштабировать чертёж, с Shift точнее',
    'Nudge by a pixel, with Shift by ten': 'Сдвинуть на пиксель, с Shift на десять',
    'Hide or show the drawing': 'Скрыть или показать чертёж',
    'Stop adjusting': 'Закончить подгонку',
    'Discard alignment': 'Сбросить выравнивание',
    'Available when the alignment finishes': 'Станет доступно, когда выравнивание закончится',
    'By two points': 'По двум точкам',
    'Corner handle': 'Угловая ручка',
    'Round handle': 'Круглая ручка',
    'Scale the drawing, with Shift by whole percents': 'Масштабировать чертёж, с Shift целыми процентами',
    'Turn the drawing, with Shift by 5°': 'Повернуть чертёж, с Shift шагом 5°',
    'Turn around the point pressed': 'Повернуть вокруг точки нажатия',
    'Drag to turn; with Shift by 5°': 'Потяните, чтобы повернуть; с Shift — шаг 5°',
    'Turn the drawing': 'Повернуть чертёж',
    'Point 1: click on the blue drawing a spot both drawings share, a corner of a shaft or of an outer wall':
        'Точка 1: щёлкните на синем чертеже место, общее для обоих, например угол шахты или наружной стены',
    'Click the same point 1 on the red drawing': 'Щёлкните ту же точку 1 на красном чертеже',
    'Point 2 on the blue drawing, as far from point 1 as you can: the farther, the more precise':
        'Точка 2 на синем чертеже, как можно дальше от точки 1: чем дальше, тем точнее',
    'Click the same point 2 on the red drawing': 'Щёлкните ту же точку 2 на красном чертеже',
    'The two points lay on each other: put them apart': 'Две точки совпали: поставьте их подальше друг от друга',
    Back: 'Назад',
    Click: 'Щелчок',
    'Put a point, when aligning by two points': 'Поставить точку при выравнивании по двум точкам',
    'The drawing cannot be shown': 'Чертёж не удаётся показать',
    'Only images uploaded to the server, with cached chunks, can be aligned':
        'Выравнивать можно только изображения, загруженные на сервер, с кэшируемыми чанками',
    'Tasks with tracks cannot be aligned': 'Задачи с треками выравнивать нельзя',
    'There are no original drawings to restore': 'Исходных чертежей для возврата нет',
    'This alignment is applied already': 'Это выравнивание уже применено',
    'The alignment has changed meanwhile. Look at it again': 'Выравнивание тем временем изменилось. Проверьте его ещё раз',
    'The drawings have changed meanwhile. Try again': 'Чертежи тем временем изменились. Попробуйте ещё раз',
    'Too few matching features': 'Слишком мало совпадающих линий',
    'The drawings cannot be matched': 'Чертежи не удаётся совместить',
    'No features found': 'На чертеже не найдено линий',
    'Interrupted: run it again': 'Прервано, запустите ещё раз',
    'Could not align this drawing': 'Не удалось выровнять этот чертёж',
    'Could not align the drawings': 'Не удалось выровнять чертежи',
    'There is no finished alignment to apply': 'Нет готового выравнивания для замены',
    'The drawings have changed since they were aligned. Align them again':
        'Чертежи изменились после выравнивания. Выровняйте их заново',
    'Processing is running here': 'Здесь уже идёт обработка',
    'Drawings are being aligned': 'Идёт выравнивание чертежей',
    'no steps to run': 'шагов для запуска нет',
    'nothing run yet': 'ничего не запускалось',
    'all steps done': 'все шаги выполнены',
    '{done} of {total} steps done': 'выполнено шагов: {done} из {total}',
    '{done} of {total} done': 'выполнено {done} из {total}',
    '{count} failed': 'с ошибкой: {count}',
    running: 'выполняется',
    ' and ': ', ',
    '{names} are not available yet.': 'Пока недоступно: {names}.',
    '{names} is not available yet.': 'Пока недоступно: {names}.',

    // task and reference pages
    Breadcrumb: 'Навигация',
    'No project': 'Без проекта',
    'Open workspace': 'Открыть редактор',
    'Open photos': 'Открыть фото',
    'More actions': 'Другие действия',
    Steps: 'Шаги',
    Detections: 'Распознанное',
    'Add drawings': 'Добавить чертежи',
    'Add photos': 'Добавить фото',
    'No drawings yet.': 'Чертежей пока нет.',
    'No photos yet.': 'Фото пока нет.',
    '{count} · the first few; all of them are in the workspace': '{count} · показаны первые, остальные в редакторе',
    'Open {n}': 'Открыть {n}',
    more: 'ещё',
    '{n} more in the workspace': 'ещё {n} в редакторе',
    'Run in the workspace →': 'Запустить в редакторе →',
    'Find models in the workspace →': 'Подобрать модели в редакторе →',
    'Could not load the steps.': 'Не удалось загрузить шаги.',
    'Could not load the references.': 'Не удалось загрузить референсы.',
    'Could not load the detections.': 'Не удалось загрузить распознанное.',
    'photos of the rooms': 'фото помещений',
    'Link existing': 'Привязать существующий',
    'Link an existing reference': 'Привязать существующий референс',
    'No photos yet. Furniture from the photos is matched to the library and placed on the drawings.':
        'Фото пока нет. Мебель с фото подбирается из библиотеки и расставляется на чертежах.',
    'About this task': 'О задаче',
    'About this reference': 'О референсе',
    Assignee: 'Исполнитель',
    'Select a user': 'Выберите пользователя',
    Created: 'Создано',
    '{date} by {user}': '{date}, {user}',
    'Project folder': 'Папка проекта',
    'Choose a folder': 'Выбрать папку',
    'Library for matching': 'Библиотека для подбора',
    'the references only': 'только референсы',
    'Libraries: {list}': 'Библиотеки: {list}',
    'Libraries for this task': 'Библиотеки для этой задачи',
    Libraries: 'Библиотеки',
    Save: 'Сохранить',
    'Delete task…': 'Удалить задачу…',
    'Delete reference…': 'Удалить референс…',
    'Delete the task “{name}”?': 'Удалить задачу «{name}»?',
    'The drawings and their annotations are removed. Linked references stay.':
        'Чертежи и их разметка будут удалены. Привязанные референсы останутся.',
    'Delete the reference “{name}”?': 'Удалить референс «{name}»?',
    'The photos and their detections are removed. The tasks stay.':
        'Фото и распознанное на них будут удалены. Задачи останутся.',
    'Could not update the task': 'Не удалось сохранить задачу',
    'Could not update the reference': 'Не удалось сохранить референс',
    'Could not change the libraries': 'Не удалось сменить библиотеки',
    'Could not change the linked tasks': 'Не удалось изменить привязанные задачи',
    'The reference was not found': 'Референс не найден',
    '{done} of {total} have a library model': 'с моделью из библиотеки: {done} из {total}',
    '{done} of {total}': '{done} из {total}',
    '{n} more categories': 'ещё категорий: {n}',
    'Fewer categories': 'Свернуть',
    'no detections yet': 'пока ничего не распознано',
    '{count}, {n} with a library model': '{count}, с моделью: {n}',
    'Nothing detected yet. Run Detect furniture in the workspace.':
        'Пока ничего не распознано. Запустите «Распознать мебель» в редакторе.',
    'drawings these photos belong to': 'чертежи, к которым относятся эти фото',
    'Link a task': 'Привязать задачу',
    'Open with these photos': 'Открыть с этими фото',
    Unlink: 'Отвязать',
    'Unlink “{name}”?': 'Отвязать «{name}»?',
    'The photos stay; they are no longer shown with that task.':
        'Фото останутся, но больше не будут показываться в этой задаче.',
    'Not linked to a task yet. The photos open inside a task, next to its drawings.':
        'Пока не привязан к задаче. Фото открываются внутри задачи, рядом с её чертежами.',

    // dialogs of the task and reference pages
    'Add at least one photo': 'Добавьте хотя бы одно фото',
    Add: 'Добавить',
    'Furniture on them is matched to the library and placed on the drawings':
        'Мебель с них подбирается из библиотеки и расставляется на чертежах',
    Link: 'Привязать',
    Reference: 'Референс',
    Task: 'Задача',
    'Choose a reference': 'Выберите референс',
    'Choose a task': 'Выберите задачу',
    'Every reference of the project is already linked to this task.': 'Все референсы проекта уже привязаны к этой задаче.',
    'Every task of the project is already linked to these photos.': 'Все задачи проекта уже привязаны к этим фото.',
    'Issue Tracker': 'Трекер задач',
    'Issue tracker is expected to be URL': 'Укажите ссылку на трекер задач',
    'Open the issue': 'Открыть задачу в трекере',
    'Could not update the project {id}': 'Не удалось сохранить проект {id}',
    'Could not update the task {id}': 'Не удалось сохранить задачу {id}',
    'Preview image': 'Превью',

    // task and reference actions
    'The task {id} will be deleted': 'Задача {id} будет удалена',
    'The reference {id} will be deleted': 'Референс {id} будет удалён',
    'Automatic models search for the task {id}': 'Автоматический поиск моделей для задачи {id}',
    'Automatic models search for the reference {id}': 'Автоматический поиск моделей для референса {id}',
    Find: 'Найти',
    'Add images': 'Добавить изображения',
    'Select Files': 'Выбрать файлы',
    'Upload annotations': 'Загрузить разметку',
    'Export task dataset': 'Экспорт датасета задачи',
    'Export reference dataset': 'Экспорт датасета референса',
    'Open bug tracker': 'Открыть трекер задач',
    'Automatic annotation': 'Автоматическая разметка',
    'Automatic 3d model search': 'Автоматический поиск 3D-моделей',
    'Backup Task': 'Резервная копия задачи',
    'Backup Reference': 'Резервная копия референса',
    'Move to project': 'Перенести в проект',
    'Automatic annotation request queued': 'Автоматическая разметка в очереди',
    'Automatic annotation is in progress': 'Идёт автоматическая разметка',
    'Automatic annotation failed': 'Автоматическая разметка не удалась',
    'Automatic annotation finished': 'Автоматическая разметка завершена',
    'Unknown status received': 'Неизвестный статус',
    'Cancel automatic annotation': 'Отменить автоматическую разметку',
    'You are going to cancel automatic annotation?': 'Отменить автоматическую разметку?',
    'Reached progress will be lost. Continue?': 'Достигнутый прогресс будет потерян. Продолжить?',

    // create project page
    'Create a new project': 'Новый проект',
    'Please, specify a name': 'Укажите название',
    'Issue tracker': 'Трекер задач',
    'Attach issue tracker where the project is described': 'Ссылка на задачу в трекере, где описан проект',
    'Issue tracker must be URL': 'Нужна ссылка',
    'Specify source storage for import resources like annotation, backups':
        'Хранилище, откуда импортируются разметка и резервные копии',
    'Specify target storage for export resources like annotation, backups':
        'Хранилище, куда экспортируются разметка и резервные копии',
    'The project has been created': 'Проект создан',
    'Project source': 'Папка проекта',
    'Please, add folder': 'Выберите папку',
    'Submit & Open': 'Создать и открыть',
    'Submit & Continue': 'Создать и продолжить',
    'Labels:': 'Метки:',
    'Advanced configuration': 'Дополнительные настройки',

    // workspace: Steps panel
    'Run remaining': 'Запустить оставшиеся',
    'Drawings to run on': 'Чертежи для запуска',
    'Photos to run on': 'Фото для запуска',
    'on this drawing': 'на этом чертеже',
    'on this photo': 'на этом фото',
    'on {n} selected': 'на {n} выбранных',
    'on all {n}': 'на всех {n}',
    'on selected (Ctrl+click drawings)': 'на выбранных (Ctrl+клик по чертежам)',
    'on selected (Ctrl+click photos)': 'на выбранных (Ctrl+клик по фото)',
    'New results are ready': 'Готовы новые результаты',
    'Save and load': 'Сохранить и загрузить',
    'Processing steps': 'Шаги обработки',
    'all of the share': 'вся общая папка',
    Run: 'Запустить',
    'Run again': 'Запустить снова',
    optional: 'необязательно',
    'Change model': 'Сменить модель',
    'Library match': 'Подбор из библиотеки',
    'Running on other drawings': 'Выполняется на других чертежах',
    'Running on other photos': 'Выполняется на других фото',
    Stop: 'Остановить',
    'Failed — {error}': 'Ошибка: {error}',
    'Retry failed': 'Повторить с ошибкой',
    recommended: 'рекомендуется',
    'not deployed': 'не развёрнута',
    '{title} on': '{title}: включено',
    '{title} model': '{title}: модель',
    off: 'выкл.',
    'failed {ago}': 'ошибка {ago}',
    'Run {names} first': 'Сначала запустите {names}',
    '{title} is switched off for this task': '{title}: шаг отключён для этой задачи',
    'Processing steps are already running here': 'Шаги обработки уже выполняются',
    'An AI request is running here. Wait until it finishes': 'Выполняется запрос к модели. Дождитесь завершения',
    'No drawings to run on': 'Нет чертежей для запуска',
    'No photos to run on': 'Нет фото для запуска',
    'Already done on these drawings. Use Run again to replace the results.':
        'На этих чертежах уже выполнено. Нажмите «Запустить снова», чтобы заменить результаты.',
    'Already done on these photos. Use Run again to replace the results.':
        'На этих фото уже выполнено. Нажмите «Запустить снова», чтобы заменить результаты.',
    'Tasks of this project use these, unless a task picks its own model.':
        'Задачи проекта используют эти модели, если в задаче не выбрана своя.',
    'Libraries for Find furniture in library': 'Библиотеки для подбора мебели',
    'Used when the task has no references': 'Используются, когда в задаче нет референсов',

    // workspace: Detections panel
    'Find models': 'Подобрать модели',
    'Find models for {count}': 'Подобрать модели: {count}',
    'Finding models… {done} of {total}': 'Подбираем модели… {done} из {total}',
    'Finding models for {label}…': 'Подбираем модели для {label}…',
    'No matches from the photos': 'Нет подбора по фото',
    'No furniture on this drawing': 'На этом чертеже нет мебели',
    Preview: 'Превью',
    'Picked on the photos of this task: {count}': 'Выбор на фото этой задачи: {count}',
    '{done} of {total} have a model from the library': 'с моделью из библиотеки: {done} из {total}',
    'Change for all': 'Сменить для всех',
    'For all {label} on this drawing ({count})': 'Для всех {label} на чертеже ({count})',
    'Photos to work on': 'Фото для работы',
    'Photo {n}': 'Фото {n}',
    'Delete this {label}?': 'Удалить «{label}»?',
    'Delete {n} {label}?': 'Удалить все «{label}» ({n})?',
    'Delete all {n}': 'Удалить все ({n})',
    'The detections are removed from the photos and the change is saved.':
        'Объекты будут удалены с фото, изменение сохранится.',
    'No detections on this photo': 'На этом фото ничего не распознано',
    'No detections in this reference': 'В этом референсе ничего не распознано',
    'No category matches the search': 'Нет категорий по запросу',
    'Switch lock property for all': 'Заблокировать или разблокировать все',
    'Switch hidden property for all': 'Скрыть или показать все',
    'Unlock all': 'Разблокировать все',
    'Lock all': 'Заблокировать все',
    'Show all': 'Показать все',
    'Hide all': 'Скрыть все',
    'Expand/collapse all': 'Развернуть или свернуть все',
    'Expand all': 'Развернуть все',
    'Collapse all': 'Свернуть все',
    'Not on the library share': 'Нет в библиотеке на общей папке',
    'No model yet': 'Без модели',
    Pick: 'Выбрать',
    'Pick a model for: {label}': 'Модель для: {label}',
    'Best {count} · most similar first': 'Лучшие {count} · сначала самые похожие',
    'Search again': 'Искать снова',
    'Remove model': 'Убрать модель',
    Cancel: 'Отмена',
    'Use selected': 'Взять выбранную',
    'No matches stored yet. Use Search again to find models.': 'Совпадений пока нет. Нажмите «Искать снова».',
    Current: 'Текущая',
    'Use this': 'Взять эту',
    'Could not change the model': 'Не удалось сменить модель',
    'Could not find models: {error}': 'Не удалось подобрать модели: {error}',
    'Could not delete: {error}': 'Не удалось удалить: {error}',
    'Your changes could not be saved': 'Не удалось сохранить изменения',
    'Press Ctrl+S to try again.': 'Нажмите Ctrl+S, чтобы попробовать ещё раз.',
    'every detection has a model': 'у всех объектов есть модель',
    'some detections have no model': 'не у всех объектов есть модель',
    'no models yet': 'моделей пока нет',

    // workspace: Scene panel
    Scene: 'Сцена',
    'Unsaved changes are not counted: save the job to see them':
        'Несохранённые изменения не учтены: сохраните задачу, чтобы их увидеть',
    'No project folder: the scene is built from the fallbacks': 'Папка проекта не подключена: сцена соберётся на запасных',
    'What assembly takes when the project lacks something': 'Что берётся, если в проекте чего-то нет',
    'The names appear once the project folder is indexed': 'Названия появятся после индексации папки проекта',
    'Without a project folder the names are not known': 'Без папки проекта названия неизвестны',
    'Not in its file': 'Нет в файле',
    Materials: 'Материалы',
    Floors: 'Полы',
    Walls: 'Стены',
    Countertops: 'Столешницы',
    Project: 'Проект',
    Fallback: 'Запасной',
    'As in the model': 'Как в модели',
    Other: 'Другой',
    '{mode} only': 'Только {mode}',
    'Not used in {mode}': 'В {mode} не используется',
    'Not in the drawings': 'На чертежах нет',
    'The material of the furniture model': 'Материал из модели мебели',
    'the material of the furniture model': 'материал из модели мебели',
    'The converter fallback': 'Запасной материал конвертера',
    '{name}: not in its file, no material': '{name}: нет в файле, будет без материала',
    '+{n} with another material': '+{n} с другим материалом',
    'Material for: {item}': 'Материал: {item}',
    'Current material': 'Текущий',
    Apply: 'Применить',
    'Now: {name}, not from the project': 'Сейчас: {name}, не из проекта',
    'For this room': 'Для этой комнаты',
    'Project materials': 'Материалы проекта',
    'Without a category': 'Без категории',
    'Also for {n} with another material': 'И для {n} с другим материалом',
    'No project materials: General_Materials/{mode} is empty or the project folder is not attached':
        'Материалов проекта нет: General_Materials/{mode} пуста или папка проекта не подключена',
    'nothing on a fallback': 'запасных нет',
    'Set up in the editor →': 'Настроить в редакторе →',
    'Could not load the scene.': 'Не удалось загрузить сцену.',
    present: 'есть',
    missing: 'нет',
    'Items on a fallback or without a model': 'Строк на запасном или без модели',
    'Materials and models for the whole task': 'Материалы и модели для всей задачи',
    'The folder is not indexed yet: project materials and fallback names appear after indexing':
        'Папка ещё не проиндексирована: материалы проекта и названия запасных появятся после индексации',
    'doors, windows, stairs': 'двери, окна, лестницы',
    'doors, windows and stairs from the shared library': 'двери, окна и лестницы из общей библиотеки',
    furniture: 'мебель',
    'furniture from the shared libraries only': 'мебель только из общих библиотек',
    materials: 'материалы',
    'materials: the fallbacks': 'материалы: запасные',
    'VR export will not start until it exists': 'VR-экспорт не начнётся, пока её нет',
    'No rooms on the drawings: run “{step}” to get the floors':
        'На чертежах нет помещений: запустите «{step}», чтобы появились полы',
    'From the shared library: the scene links them': 'Из общей библиотеки, сцена ссылается на них',
    'Model for: {item}': 'Модель: {item}',
    'Now: {name}, not from the library': 'Сейчас: {name}, не из библиотеки',
    'Also for {n} with another model': 'И для {n} с другой моделью',
    Spots: 'Споты',
    Curtains: 'Шторы',
    Tulle: 'Тюль',
    Library: 'Библиотека',
    'No model': 'Без модели',
    '+{n} with another model': '+{n} с другой моделью',
    'VR walls take no material: they have no material input': 'В VR материал стен не применяется: у стен VR нет входа для материала',
    'FP windows are built without curtains': 'В FP окна собираются без штор',
    'FP windows are built without tulle': 'В FP окна собираются без тюля',
    'No walls on the drawings': 'На чертежах нет стен',
    'No kitchens or sinks on the drawings': 'На чертежах нет кухонь и раковин',
    'No spots on the drawings': 'На чертежах нет спотов',
    'No windows on the drawings': 'На чертежах нет окон',
    'No model: the spots are not placed': 'Без модели: споты не ставятся',
    'No model: the windows get no curtains': 'Без модели: окна без штор',
    'No model: the windows get no tulle': 'Без модели: окна без тюля',
    Own: 'Своё',
    'As in the scene: {name}': 'Как в сцене: {name}',
    'Fallback: {name}': 'Запасной: {name}',
    'Drawing {n} · #{id}': 'Чертёж {n} · #{id}',
    'job {id}': 'задание {id}',
    'Show on the drawing': 'Показать на чертеже',
    Replace: 'Заменить',
    'Replace with «{name}»': 'Заменить на «{name}»',
    'Replace all with «{name}»': 'Заменить все на «{name}»',
    '{n} more': 'Ещё {n}',
    'Replace the material of {count} with «{name}»?': 'Заменить материал {count} на «{name}»?',
    'Replace the model of {count} with «{name}»?': 'Заменить модель {count} на «{name}»?',
    'Previously assigned materials will be replaced with the scene material.':
        'Ранее назначенные материалы заменятся материалом сцены.',
    'Previously assigned models will be replaced with the scene model.':
        'Ранее назначенные модели заменятся моделью сцены.',
    '{n} need attention': 'требуют внимания: {n}',
    'On a fallback or without a model: {items}': 'На запасном или без модели: {items}',
    'Living room': 'Гостиная',
    Bedroom: 'Спальня',
    'Master bedroom': 'Мастер-спальня',
    'Guest room': 'Гостевая',
    "Children's room": 'Детская',
    Bathroom: 'Санузел',
    Kitchen: 'Кухня',
    'Dining room': 'Столовая',
    Pantry: 'Кладовая',
    'Study room': 'Кабинет',
    Laundry: 'Прачечная',
    'Storage room': 'Подсобка',
    'Home theater': 'Домашний кинотеатр',
    Gym: 'Спортзал',
    Hallway: 'Коридор',
    Garage: 'Гараж',
    'Mechanical room': 'Техническое помещение',
    Closet: 'Гардеробная',
    Terrace: 'Терраса',
    Balcony: 'Балкон',
    'Living-dining room': 'Гостиная-столовая',
    "Maid's room": 'Комната прислуги',
    Majlis: 'Маджлис',
    'Service room': 'Служебное помещение',
    'Family room': 'Семейная гостиная',

    // workspace: strip, bar, menus
    'Drawing {n}': 'Чертёж {n}',
    'Delete drawing {n}': 'Удалить чертёж {n}',
    'Delete photo {n}': 'Удалить фото {n}',
    'Delete drawing': 'Удалить чертёж',
    'Delete photo': 'Удалить фото',
    'Delete drawing {n}?': 'Удалить чертёж {n}?',
    'Delete photo {n}?': 'Удалить фото {n}?',
    'The drawing is hidden and skipped by export. Open it with "Show deleted frames" to restore it.':
        'Чертёж будет скрыт и пропущен при экспорте. Вернуть его можно через «Показывать удалённые кадры».',
    'The photo is hidden and skipped by export. Open it with "Show deleted frames" to restore it.':
        'Фото будет скрыто и пропущено при экспорте. Вернуть его можно через «Показывать удалённые кадры».',
    'some steps done': 'выполнена часть шагов',
    processing: 'обрабатывается',
    'a step failed': 'шаг завершился с ошибкой',
    'not processed': 'не обработан',
    'Select files': 'Выбрать файлы',
    'Could not add drawings': 'Не удалось добавить чертежи',
    'Could not add photos': 'Не удалось добавить фото',
    'Could not add images': 'Не удалось добавить изображения',
    'Save order': 'Сохранить порядок',
    'Could not save the order': 'Не удалось сохранить порядок',
    'Project #{id}': 'Проект №{id}',
    'Fit to screen': 'Вписать в экран',
    'Sorry, but this job was not found': 'Задача не найдена',
    'Please, be sure information you tried to get exist and you have access':
        'Проверьте, что задача существует и у вас есть к ней доступ',
    'Back to projects': 'К проектам',
    'No references linked to this task': 'К задаче не привязаны референсы',
    Job: 'Задача',
    Workspace: 'Режим',
    Filters: 'Фильтры',
    Info: 'Информация',
    Guide: 'Инструкция',
    'Restore frame': 'Восстановить кадр',
    'Delete frame': 'Удалить кадр',
    'Copy frame link': 'Копировать ссылку на кадр',
    Fullscreen: 'Во весь экран',
    'Keyboard shortcuts': 'Горячие клавиши',
    'Saving…': 'Сохраняем…',
    'Unsaved changes': 'Есть несохранённые изменения',
    Saved: 'Сохранено',
    'Export .blend': 'Экспорт .blend',
    'Press “{key}” to finish': 'Нажмите «{key}», чтобы завершить',
    Done: 'Готово',
    'Press “{key}” to postpone running the algorithm': 'Нажмите «{key}», чтобы отложить запуск алгоритма',
    Block: 'Блокировать',
    Undo: 'Отменить',
    Redo: 'Повторить',
    'Undo: {action} {key}': 'Отменить: {action} {key}',
    'Redo: {action} {key}': 'Повторить: {action} {key}',
    'Open in reference editor': 'Открыть в редакторе референса',

    // workspace: Appearance and sidebar
    Appearance: 'Внешний вид',
    'One by one': 'По одному',
    'All at once': 'Все сразу',
    'Color by': 'Цвет по',
    Label: 'Метка',
    Instance: 'Объекту',
    Group: 'Группе',
    Opacity: 'Непрозрачность',
    'Selected opacity': 'Непрозрачность выбранного',
    'Outlined borders': 'Контур',
    'Show bitmap': 'Показать маску',
    'Show projections': 'Показать проекции',
    Show: 'Показать',
    'Hide sidebar': 'Скрыть панель',
    Objects: 'Объекты',
    'Issues {n}': 'Замечания {n}',
    'Unlock {name}': 'Разблокировать {name}',
    'Lock {name}': 'Заблокировать {name}',
    'Show {name}': 'Показать {name}',
    'Hide {name}': 'Скрыть {name}',
    'More for {name}': 'Ещё для {name}',
    'Search by label': 'Найти метку',
    'Switch lock property for all {key}': 'Заблокировать или разблокировать все {key}',
    'Switch hidden property for all {key}': 'Скрыть или показать все {key}',
    'Show Ground truth annotations and conflicts': 'Показать эталонную разметку и конфликты',
    'Sort by': 'Сортировка',
    'ID - descent': 'ID по убыванию',
    'ID - ascent': 'ID по возрастанию',
    'Updated time': 'Время изменения',
    'Z Order': 'Порядок по Z',
    'Default label has been changed to “{name}”': 'Метка по умолчанию: «{name}»',
    'Find the previous frame with issues': 'Предыдущий кадр с замечаниями',
    'Find the next frame with issues': 'Следующий кадр с замечаниями',
    'Show/hide all issues': 'Показать или скрыть все замечания',
    'Show/hide resolved issues': 'Показать или скрыть решённые замечания',
    'created {ago}': 'создано {ago}',
    Warning: 'Предупреждение',
    Conflict: 'Конфликт',
    Reset: 'Сбросить',
    Ok: 'ОК',
    'Select color': 'Выберите цвет',
    Close: 'Закрыть',

    // workspace: modes in the More menu
    Standard: 'Стандартный',
    'Standard 3D': 'Стандартный 3D',
    'Attribute annotation': 'Разметка атрибутов',
    'Tag annotation': 'Разметка тегов',
    Review: 'Проверка',

    // workspace: objects
    '{shape} shape': '{shape}',
    '{shape} track': '{shape}, трек',
    rectangle: 'прямоугольник',
    polygon: 'многоугольник',
    polyline: 'ломаная',
    points: 'точки',
    ellipse: 'эллипс',
    cuboid: 'кубоид',
    mask: 'маска',
    skeleton: 'скелет',
    shape: 'фигура',
    track: 'трек',
    tag: 'тег',
    any: 'любой',
    PARTS: 'ЧАСТИ',
    DETAILS: 'АТРИБУТЫ',
    'Change current label': 'Сменить метку',
    'Go to previous keyframe {key}': 'К предыдущему ключевому кадру {key}',
    'Go to next keyframe {key}': 'К следующему ключевому кадру {key}',
    'Switch lock property {key}': 'Заблокировать или разблокировать {key}',
    'Switch occluded property {key}': 'Перекрыт или нет {key}',
    'Switch pinned property': 'Закрепить или открепить',
    'Switch hidden property {key}': 'Скрыть или показать {key}',
    'Switch outside property {key}': 'Вне кадра или нет {key}',
    'Switch keyframe property {key}': 'Ключевой кадр или нет {key}',
    'Create object URL': 'Ссылка на объект',
    '{copy} and {paste}': '{copy} и {paste}',
    'Make a copy': 'Копировать',
    'Shift + Double click': 'Shift + двойной клик',
    Edit: 'Изменить',
    'Cut the shape into two parts {key}': 'Разрезать фигуру на две части {key}',
    Slice: 'Разрезать',
    Propagate: 'Распространить',
    'Switch orientation': 'Сменить направление',
    'Reset perspective': 'Сбросить перспективу',
    'To background': 'На задний план',
    'To foreground': 'На передний план',
    'Change label color': 'Сменить цвет метки',
    'Change instance color': 'Сменить цвет объекта',
    'Change group color': 'Сменить цвет группы',
    Remove: 'Удалить',

    // workspace: left toolbar
    'Cursor {key}': 'Курсор {key}',
    'Move the image': 'Перемещать изображение',
    'Rotate the image anticlockwise {key}': 'Повернуть против часовой {key}',
    'Rotate the image clockwise {key}': 'Повернуть по часовой {key}',
    'Fit the image [Double Click]': 'Вписать изображение [двойной клик]',
    'Select a region of interest': 'Выделить область',
    'Crop image': 'Обрезать изображение',
    'Draw new rectangle': 'Новый прямоугольник',
    'Draw new polygon': 'Новый многоугольник',
    'Draw new polyline': 'Новая ломаная',
    'Draw new points': 'Новые точки',
    'Draw new ellipse': 'Новый эллипс',
    'Draw new cuboid': 'Новый кубоид',
    'Draw new mask': 'Новая маска',
    'Draw new skeleton': 'Новый скелет',
    'Drawing method': 'Способ рисования',
    'By 2 Points': 'По 2 точкам',
    'By 4 Points': 'По 4 точкам',
    'From rectangle': 'Из прямоугольника',
    'Number of points:': 'Число точек:',
    'Press {key} to draw again': 'Нажмите {key}, чтобы нарисовать ещё',
    Shape: 'Фигура',
    Track: 'Трек',
    'Setup tag': 'Новый тег',
    'Press {key} to add a tag again': 'Нажмите {key}, чтобы добавить тег ещё раз',
    'Group shapes/tracks {key}': 'Группировать фигуры и треки {key}',
    'Select and press {key} to reset a group.': 'Выделите и нажмите {key}, чтобы сбросить группу.',
    'Join masks {key}': 'Объединить маски {key}',
    'Merge shapes/tracks {key}': 'Слить фигуры и треки {key}',
    'Slice a mask/polygon shape {key}': 'Разрезать маску или многоугольник {key}',
    'Split a track {key}': 'Разделить трек {key}',
    less: 'меньше',
    'Points:': 'Точки:',
    'Selected interactor does not have a help message': 'Для этого инструмента нет подсказки',
    'You can prevent server requests holding': 'Чтобы не отправлять запросы на сервер, удерживайте',
    key: '',
    'Positive points can be added by left-clicking the image.': 'Положительные точки ставятся левым кликом.',
    'Negative points can be added by right-clicking the image.': 'Отрицательные точки ставятся правым кликом.',
    'Example gif': 'Пример',
    'Select an interactor to see help message': 'Выберите инструмент, чтобы увидеть подсказку',
    'AI Tools': 'Инструменты ИИ',
    Interactors: 'Интерактивные',
    Detectors: 'Детекторы',
    Trackers: 'Трекеры',
    Interactor: 'Инструмент',
    Interact: 'Применить',
    Tracker: 'Трекер',
    'Convert masks to polygons': 'Превращать маски в многоугольники',
    'No available interactors found': 'Нет доступных интерактивных инструментов',
    'No available detectors found': 'Нет доступных детекторов',
    'No available trackers found': 'Нет доступных трекеров',
    'Trackable ({name})': 'Отслеживается ({name})',
    'Enable tracking using {name}': 'Отслеживать с помощью {name}',
    'Disable tracking': 'Не отслеживать',
    'Waiting a response from {name}..': 'Ждём ответа от {name}…',
    'Making a server request': 'Запрос к серверу',
    'Waiting for a server response..': 'Ждём ответа сервера…',
    'Interaction error occurred': 'Ошибка инструмента',
    'Detection error occurred': 'Ошибка распознавания',
    'Tracking error occurred': 'Ошибка отслеживания',
    'Tracking error': 'Ошибка отслеживания',
    'Tracker initialization error': 'Не удалось запустить трекер',
    'Suitable tracker with ID {id} not found in tracker list': 'Трекер с ID {id} не найден',
    'Interactor API is outdated': 'Устаревший API инструмента',
    'Probably, you should consider updating the serverless function': 'Возможно, нужно обновить функцию на сервере',
    'Could not initialize OpenCV': 'Не удалось загрузить OpenCV',
    'Could not initialize OpenCV library': 'Не удалось загрузить библиотеку OpenCV',
    'OpenCV.js processing error occurred': 'Ошибка обработки OpenCV.js',
    'Intelligent scissors': 'Умные ножницы',
    'Histogram equalization': 'Выравнивание гистограммы',
    'OpenCV is loading': 'OpenCV загружается',
    'Reload OpenCV': 'Перезагрузить OpenCV',
    Drawing: 'Рисование',
    Image: 'Изображение',
    Tracking: 'Отслеживание',
    'Request failed with status {status}': 'Ошибка запроса, статус {status}',
    Error: 'Ошибка',
    'Saving changes on the server': 'Сохраняем изменения на сервере',
    'Searching for matching 3D models based on your image. Please wait.': 'Ищем подходящие 3D-модели по изображению. Подождите.',
    'Select library': 'Выберите библиотеку',
    'Choose at least one library before starting the search.': 'Выберите хотя бы одну библиотеку перед поиском.',
    'Select the directory for 3D models search': 'Папка для поиска 3D-моделей',
    'Directory must be selected': 'Выберите папку',
    'Select directory': 'Выбрать папку',
    Search: 'Искать',

    // workspace: job menu, Info and Filters
    'The job has unsaved annotations': 'В задаче есть несохранённая разметка',
    'Would you like to save changes before continue?': 'Сохранить изменения перед продолжением?',
    'Remove Annotations': 'Удалить разметку',
    'Remove annotations': 'Удалить разметку',
    'You are going to remove the annotations from the client.': 'Разметка будет удалена в браузере.',
    'It will stay on the server till you save the job. Continue?': 'На сервере она останется, пока вы не сохраните задачу. Продолжить?',
    'Select Range': 'Диапазон',
    'From:': 'С:',
    'To:': 'по:',
    'Applicable only for annotations in range': 'Только для разметки в диапазоне',
    'Delete only keyframes for tracks': 'Удалять у треков только ключевые кадры',
    'Do you want to change current job state?': 'Сменить состояние задачи?',
    'Job state will be switched to “{state}”. Continue?': 'Состояние задачи станет «{state}». Продолжить?',
    'The job stage is going to be switched': 'Этап задачи будет изменён',
    'Stage will be changed to "acceptance". Would you like to continue?': 'Этап станет «приёмка». Продолжить?',
    'Do you want to renew the job?': 'Вернуть задачу в работу?',
    'Stage will be set to "in progress", state will be set to "annotation". Would you like to continue?':
        'Этап станет «в работе», состояние «разметка». Продолжить?',
    'Export job dataset': 'Экспорт датасета задачи',
    'Export Blender files': 'Экспорт файлов Blender',
    'Run actions': 'Действия',
    'Open the task': 'Открыть задачу',
    'Change job state': 'Сменить состояние задачи',
    'Finish the job': 'Завершить задачу',
    'Renew the job': 'Вернуть в работу',
    new: 'новая',
    'in progress': 'в работе',
    completed: 'завершена',
    rejected: 'отклонена',
    Nobody: 'Никто',
    Total: 'Всего',
    'Shapes / Tracks': 'Фигуры / треки',
    Tag: 'Тег',
    Manually: 'Вручную',
    Interpolated: 'Интерполировано',
    Overview: 'Обзор',
    'Start frame': 'Первый кадр',
    'Stop frame': 'Последний кадр',
    Frames: 'Кадры',
    'Bug tracker': 'Трекер задач',
    'Annotations statistics': 'Статистика разметки',
    Rectangle: 'Прямоугольник',
    Polygon: 'Многоугольник',
    Polyline: 'Ломаная',
    Points: 'Точки',
    Ellipse: 'Эллипс',
    Cuboid: 'Кубоид',
    Cuboids: 'Кубоиды',
    Skeleton: 'Скелет',
    Mask: 'Маска',
    Type: 'Тип',
    Occluded: 'Перекрыт',
    Width: 'Ширина',
    Height: 'Высота',
    ObjectID: 'ID объекта',
    ServerID: 'ID на сервере',
    Attributes: 'Атрибуты',
    'Clear filters': 'Сбросить фильтры',
    Submit: 'Применить',

    // notifications: objects in links
    task: 'задача',
    project: 'проект',
    job: 'задача',
    reference: 'референс',
    Dataset: 'Датасет',
    Annotations: 'Разметка',
    'downloaded locally': 'скачано на компьютер',
    'uploaded to cloud storage': 'загружено в облачное хранилище',

    // notifications: workspace
    'You finished working on frame {n}': 'Вы остановились на кадре {n}',
    Press: 'Нажмите',
    here: 'здесь',
    'if you would like to continue': ', чтобы продолжить',
    'No labels': 'Нет меток',
    'Reference {id} does not contain any label.': 'В референсе {id} нет меток.',
    'Project {id} does not contain any label.': 'В проекте {id} нет меток.',
    'Task {id} does not contain any label.': 'В задаче {id} нет меток.',
    'the first one for editing annotation.': 'первую, чтобы размечать.',
    'Frame {n} cropped successfully': 'Кадр {n} обрезан',
    'Frame {n} not cropped': 'Не удалось обрезать кадр {n}',
    'No value to copy': 'Нечего копировать',
    'Please provide a value to copy.': 'Укажите значение для копирования.',
    '“{name}” copied to clipboard': '«{name}» скопировано',
    'The value “{value}” has been copied successfully.': 'Значение «{value}» скопировано.',
    'Failed to copy': 'Не удалось скопировать',
    'There was an error copying the value to clipboard.': 'Не удалось скопировать значение в буфер обмена.',
    'Open the Browser Console to get details': 'Подробности в консоли браузера',
    'Job renewed': 'Задача возвращена в работу',
    'Job state updated': 'Состояние задачи изменено',
    'Image processing error occurred': 'Ошибка обработки изображения',
    'Canvas error occurred': 'Ошибка холста',
    'Some objects were deleted': 'Часть объектов удалена',
    'As a result of removing the underlying pixels, some masks became empty and were subsequently deleted.':
        'После удаления пикселей некоторые маски стали пустыми и были удалены.',
    'Could not fetch context images. Frame: {n}': 'Не удалось загрузить контекстные изображения. Кадр: {n}',
    'Could not receive annotation guide': 'Не удалось загрузить инструкцию',
    'Only ZIP archive is supported': 'Поддерживается только ZIP-архив',
    'Only ZIP archive is supported for import a dataset': 'Для импорта датасета поддерживается только ZIP-архив',

    // notifications: move to project
    'Move task {id} to project': 'Перенести задачу {id} в проект',
    'Move reference {id} to project': 'Перенести референс {id} в проект',
    'Some moving process description here': 'Перенос в другой проект с сопоставлением меток',
    'Project:': 'Проект:',
    'Label mapping': 'Сопоставление меток',
    'Please, select a project': 'Выберите проект',
    'Please, specify mapping for all the labels': 'Сопоставьте все метки',
    'Could not fetch task from the server': 'Не удалось загрузить задачу',
    'Could not fetch reference from the server': 'Не удалось загрузить референс',

    // notifications: CVAT errors and results
    'Could not check authorization on the server': 'Не удалось проверить авторизацию',
    'Could not login on the server': 'Не удалось войти',
    'Could not logout from the server': 'Не удалось выйти',
    'Could not register on the server': 'Не удалось зарегистрироваться',
    'To use your account, you need to confirm the email address. We have sent an email with a confirmation link to {email}.':
        'Подтвердите адрес почты, чтобы пользоваться аккаунтом. Мы отправили письмо со ссылкой на {email}.',
    'New password has been saved.': 'Новый пароль сохранён.',
    'Could not change password': 'Не удалось сменить пароль',
    'Could not reset password on the server.': 'Не удалось сбросить пароль.',
    'Check your email for a link to reset your password. If it doesn’t appear within a few minutes, check your spam folder.':
        'Проверьте почту: там ссылка для сброса пароля. Если письма нет несколько минут, загляните в спам.',
    'Password has been reset with the new password.': 'Пароль сброшен, установлен новый.',
    'Could not set new password on the server.': 'Не удалось установить новый пароль.',
    'Could not receive server schema': 'Не удалось получить схему API',
    'Could not get invitations': 'Не удалось загрузить приглашения',
    'Could not accept invitation': 'Не удалось принять приглашение',
    'Could not decline invitation': 'Не удалось отклонить приглашение',
    'Could not resend invitation': 'Не удалось отправить приглашение повторно',
    'Invitation was sent successfully': 'Приглашение отправлено',
    'Could not export dataset for the [{type} {id}]({url})': 'Не удалось экспортировать датасет: [{type} {id}]({url})',
    '{resource} for {type} {id} {verb} been {how}': '{resource} ({type} {id}): {how}',
    'Could not export the {type} №{id}': 'Не удалось сделать резервную копию: {type} №{id}',
    'Backup for the {type} №{id} has been {how}': 'Резервная копия ({type} №{id}): {how}',
    'Could not find models for the [{type} {id}]({url})': 'Не удалось подобрать модели: [{type} {id}]({url})',
    'Model search was finished successfully': 'Подбор моделей завершён',
    'Annotations have been loaded to the [{type} {id}]({url})': 'Разметка загружена: [{type} {id}]({url})',
    'Dataset was imported to the [{type} {id}]({url})': 'Датасет импортирован: [{type} {id}]({url})',
    'Could not upload annotation for the [{type} {id}]({url})': 'Не удалось загрузить разметку: [{type} {id}]({url})',
    'Could not import dataset to the [{type} {id}]({url})': 'Не удалось импортировать датасет: [{type} {id}]({url})',
    'The {type} has been restored successfully. Click [here]({url}) to open':
        'Восстановлено из резервной копии: {type}. [Открыть]({url})',
    'Could not restore {type} backup.': 'Не удалось восстановить из резервной копии: {type}.',
    'Could not fetch tasks': 'Не удалось загрузить задачи',
    'Could not delete the [{type} {id}]({url})': 'Не удалось удалить: [{type} {id}]({url})',
    'Could not create the task': 'Не удалось создать задачу',
    'Could not fetch references': 'Не удалось загрузить референсы',
    'Could not create the reference': 'Не удалось создать референс',
    'Could not fetch projects': 'Не удалось загрузить проекты',
    'Could not create the project': 'Не удалось создать проект',
    'Could not get formats from the server': 'Не удалось получить список форматов',
    'Could not get info about the server': 'Не удалось получить сведения о сервере',
    'Could not get models from the server': 'Не удалось получить список моделей',
    'Could not fetch models meta information': 'Не удалось получить сведения о моделях',
    'Automatic annotation accomplished for the [{type} {id}]({url})': 'Автоматическая разметка завершена: [{type} {id}]({url})',
    'Fetching inference status for the [{type} {id}]({url})': 'Не удалось получить статус автоматической разметки: [{type} {id}]({url})',
    'Could not infer model for the [{type} {id}]({url})': 'Не удалось запустить модель: [{type} {id}]({url})',
    'Could not cancel model inference for the [{type} {id}]({url})': 'Не удалось остановить модель: [{type} {id}]({url})',
    'Could not receive frame {n}': 'Не удалось загрузить кадр {n}',
    'Could not receive image data': 'Не удалось загрузить изображение',
    'Error during fetching a job': 'Не удалось открыть задачу',
    'Could not fetch annotations': 'Не удалось загрузить разметку',
    'Could not save annotations': 'Не удалось сохранить разметку',
    'Could not update annotations': 'Не удалось обновить разметку',
    'Could not create annotations': 'Не удалось создать разметку',
    'Could not merge annotations': 'Не удалось слить объекты',
    'Could not group annotations': 'Не удалось сгруппировать объекты',
    'Could not join annotations': 'Не удалось объединить маски',
    'Could not slice the object': 'Не удалось разрезать объект',
    'Could not split the track': 'Не удалось разделить трек',
    'Could not remove the object': 'Не удалось удалить объект',
    'Could not propagate the object': 'Не удалось распространить объект',
    'Could not collect annotations statistics': 'Не удалось собрать статистику разметки',
    'Could not remove annotations': 'Не удалось удалить разметку',
    'Could not undo': 'Не удалось отменить',
    'Could not redo': 'Не удалось повторить',
    'Could not execute search annotations': 'Не удалось выполнить поиск по разметке',
    'Could not search an empty frame': 'Не удалось найти пустой кадр',
    'Could not delete frame': 'Не удалось удалить кадр',
    'Could not restore frame': 'Не удалось восстановить кадр',
    'Could not reset the state': 'Не удалось сбросить состояние',
    'Could not open a new issue': 'Не удалось создать замечание',
    'Could not resolve the issue': 'Не удалось закрыть замечание',
    'Could not reopen the issue': 'Не удалось открыть замечание заново',
    'Could not comment the issue': 'Не удалось прокомментировать замечание',
    'Could not remove issue from the server': 'Не удалось удалить замечание',
    'Could not submit review for the job {id}': 'Не удалось отправить проверку задачи {id}',
    'Could not send logs to the server': 'Не удалось отправить журнал на сервер',
    'Could not create the cloud storage': 'Не удалось создать облачное хранилище',
    'Could not fetch cloud storage': 'Не удалось загрузить облачное хранилище',
    'Could not update cloud storage #{id}': 'Не удалось обновить облачное хранилище №{id}',
    'Could not delete cloud storage #{id}': 'Не удалось удалить облачное хранилище №{id}',
    'Could not fetch content for cloud storage #{id}': 'Не удалось загрузить содержимое облачного хранилища №{id}',
    'Could not fetch cloud storage #{id} status': 'Не удалось получить статус облачного хранилища №{id}',
    'Could not fetch preview for cloud storage #{id}': 'Не удалось загрузить превью облачного хранилища №{id}',
    'Could not create organization {name}': 'Не удалось создать организацию {name}',
    'Could not update organization {name}': 'Не удалось обновить организацию {name}',
    'Could not activate organization {name}': 'Не удалось переключиться на организацию {name}',
    'Could not remove organization {name}': 'Не удалось удалить организацию {name}',
    'Could not invite organization members': 'Не удалось пригласить участников',
    'Could not invite “{email}” to the organization': 'Не удалось пригласить «{email}» в организацию',
    'Could not leave the organization': 'Не удалось выйти из организации',
    'Could not remove “{user}” from the organization': 'Не удалось удалить «{user}» из организации',
    'Could not assign the role “{role}” to “{user}”': 'Не удалось назначить роль «{role}» пользователю «{user}»',
    'Could not fetch a list of jobs': 'Не удалось загрузить список задач',
    'Could not create job': 'Не удалось создать задачу',
    'Could not update job': 'Не удалось обновить задачу',
    'Could not delete the job #{id}': 'Не удалось удалить задачу №{id}',
    'Could not fetch a list of webhooks': 'Не удалось загрузить вебхуки',
    'Could not create webhook': 'Не удалось создать вебхук',
    'Could not update webhook': 'Не удалось обновить вебхук',
    'Could not delete webhook': 'Не удалось удалить вебхук',
    'Could not get user agreements from the server': 'Не удалось получить пользовательские соглашения',

    // labels editor
    Raw: 'Текстом',
    Constructor: 'Конструктор',
    'Add label': 'Добавить метку',
    'Setup skeleton': 'Настроить скелет',
    'From model': 'Из модели',
    'Update attributes': 'Изменить атрибуты',
    'Delete label': 'Удалить метку',
    'Sub-labels': 'Подметки',
    'Label name': 'Название метки',
    'Please specify a name': 'Укажите название',
    'An HTML element representing the attribute': 'Элемент, которым задаётся атрибут',
    Select: 'Список',
    Radio: 'Переключатель',
    Checkbox: 'Флажок',
    Text: 'Текст',
    Number: 'Число',
    Color: 'Цвет',
    'Press enter to add a new value': 'Нажмите Enter, чтобы добавить значение',
    'Please specify values': 'Укажите значения',
    'Attribute values': 'Значения атрибута',
    'This value is default': 'Значение по умолчанию',
    'Click to set default value': 'Нажмите, чтобы сделать значением по умолчанию',
    'Specify a default value': 'Значение по умолчанию',
    'Please, specify a default value': 'Укажите значение по умолчанию',
    False: 'Нет',
    True: 'Да',
    'Invalid attribute value: “{value}”': 'Недопустимое значение атрибута: «{value}»',
    '“{value}” is not a number': '«{value}» не число',
    'Please set a range': 'Укажите диапазон',
    'Change color of the material': 'Сменить цвет материала',
    'Default value': 'По умолчанию',
    'Can this attribute be changed frame to frame?': 'Может ли атрибут меняться от кадра к кадру?',
    Mutable: 'Изменяемый',
    'Delete the attribute': 'Удалить атрибут',
    'Do you want to remove the “{name}” attribute?': 'Удалить атрибут «{name}»?',
    'This action is irreversible. It will remove corresponding annotations.':
        'Это действие необратимо: связанная разметка будет удалена.',
    'Add an attribute': 'Добавить атрибут',
    'Save the label and return': 'Сохранить метку и вернуться',
    'Save the label and create one more': 'Сохранить метку и создать ещё',
    'Do not save the label and return': 'Вернуться без сохранения',
    'Change color of the label': 'Сменить цвет метки',
    'Do you want to delete the “{name}” label?': 'Удалить метку «{name}»?',
    'This action is irreversible. Annotation corresponding with this label will be deleted.':
        'Это действие необратимо: разметка с этой меткой будет удалена.',
    'Select a model to pick labels:': 'Выберите модель, из которой взять метки:',
    'No deployed models found': 'Нет развёрнутых моделей',
    'Labels not found in the specified model': 'В модели нет меток',
    'You are going to remove existing labels/attributes': 'Будут удалены существующие метки и атрибуты',
    'Following labels are going to be removed:': 'Будут удалены метки:',
    'Following attributes are going to be removed:': 'Будут удалены атрибуты:',
    'All related annotations will be destroyed. Continue?': 'Связанная разметка будет удалена. Продолжить?',
    'Delete existing data': 'Удалить данные',
    'Save labels': 'Сохранить метки',
    'Reset all changes': 'Сбросить изменения',
    'Upload a background image': 'Загрузить фоновое изображение',
    'Click the canvas to add a point': 'Нажмите на холст, чтобы добавить точку',
    'Click and drag points': 'Перетаскивайте точки',
    'Click two points to setup an edge': 'Нажмите две точки, чтобы соединить их',
    'Click an element to remove it': 'Нажмите на элемент, чтобы удалить его',
    'Download skeleton as SVG': 'Скачать скелет как SVG',
    'Upload a skeleton from SVG': 'Загрузить скелет из SVG',
    'Wrong skeleton structure': 'Неверная структура скелета',
    'File must be a JPEG or PNG image. Detected type: “{type}”': 'Нужно изображение JPEG или PNG. Тип файла: «{type}»',
    Configure: 'Настроить',

    // export modals and storage fields
    'project #{id}': 'проект №{id}',
    'task #{id}': 'задача №{id}',
    'job #{id}': 'задача №{id}',
    'reference #{id}': 'референс №{id}',
    reference_job: 'задача референса',
    SingleFile: 'Файл .blend',
    'Export {target} as a dataset': 'Экспорт датасета: {target}',
    'Export Blender files from {target}': 'Экспорт в Blender: {target}',
    'Export {target}': 'Резервная копия: {target}',
    'Export format': 'Формат',
    'Format must be selected': 'Выберите формат',
    'Select dataset format': 'Выберите формат датасета',
    'Save images': 'Сохранить изображения',
    'Custom name': 'Имя файла',
    'Custom name for a dataset': 'Имя архива с датасетом',
    'Custom name for a backup file': 'Имя файла резервной копии',
    'Custom name for archive': 'Имя архива',
    'Use default settings': 'Настройки по умолчанию',
    'Export to local storage {id}': 'Экспорт в локальное хранилище {id}',
    'Export to cloud storage {id}': 'Экспорт в облачное хранилище {id}',
    'Export backup to local storage {id}': 'Резервная копия сохранится в локальное хранилище {id}',
    'Export backup to cloud storage {id}': 'Резервная копия сохранится в облачное хранилище {id}',
    'Specify target storage for export dataset': 'Хранилище, куда экспортируется датасет',
    'Specify target storage for export Blender files': 'Хранилище, куда экспортируются файлы Blender',
    'Specify target storage for export {target}': 'Хранилище для резервной копии: {target}',
    'Dataset export started': 'Экспорт датасета запущен',
    'Annotations export started': 'Экспорт разметки запущен',
    'Blender export started': 'Экспорт в Blender запущен',
    'Dataset export was started for {target}. Download will start automatically as soon as the Dataset is ready.':
        'Экспорт запущен: {target}. Скачивание начнётся само, когда датасет будет готов.',
    'Annotations export was started for {target}. Download will start automatically as soon as the Annotations is ready.':
        'Экспорт запущен: {target}. Скачивание начнётся само, когда разметка будет готова.',
    'Blender export was started for {target}. Download will start automatically as soon as the Blender is ready.':
        'Экспорт запущен: {target}. Скачивание начнётся само, когда файлы Blender будут готовы.',
    'Backup export started': 'Резервное копирование запущено',
    'Backup export was started. Download will start automatically as soon as the file is ready.':
        'Резервное копирование запущено. Скачивание начнётся само, когда файл будет готов.',
    'Treat Floors as Levels': 'Многоэтажная сборка',
    'Use AutoLP': 'Использовать AutoLP',
    'Export for Addon': 'Экспорт для аддона',
    'No project folder is attached to this task: the export builds from the bundled assets.':
        'К задаче не привязана папка проекта: экспорт соберётся из встроенных ассетов.',
    'Asset set': 'Набор ассетов',
    Floorplan: 'Планировка',
    'Scene name': 'Имя сцены',
    'Example: MODON001_Hudayriyat_S007 or ALDAR039_NYU_LVL1-3. The export appends _FP_link / _VR_link (or _unlink) and names the LP file _LP.':
        'Например: MODON001_Hudayriyat_S007 или ALDAR039_NYU_LVL1-3. Экспорт допишет _FP_link / _VR_link (или _unlink), а файл LP получит окончание _LP.',
    'Current frame ({n})': 'Текущий кадр ({n})',
    Range: 'Диапазон',
    'All frames': 'Все кадры',
    to: 'до',
    'Specify the first frame': 'Укажите первый кадр',
    'Specify the last frame': 'Укажите последний кадр',
    'The first frame is after the last one': 'Первый кадр идёт после последнего',
    'Source storage': 'Исходное хранилище',
    'Target storage': 'Целевое хранилище',
    Local: 'Локальное',
    'Cloud storage': 'Облачное хранилище',
    'Could not fetch a list of cloud storages': 'Не удалось загрузить список облачных хранилищ',
    'Select cloud storage': 'Облачное хранилище',
    'Please, specify a cloud storage': 'Выберите облачное хранилище',
    'Search...': 'Поиск…',

    // step messages from the server
    'no photos yet': 'фото пока нет',
    'The task has no labels for this step': 'В задаче нет меток для этого шага',
    'Link references or pick a library in Models and defaults':
        'Привяжите референсы или выберите библиотеку в «Модели и настройки по умолчанию»',
    "None of this step's models is deployed": 'Ни одна модель этого шага не развёрнута',
    'The model took too long to answer. Try again.': 'Модель не ответила вовремя. Попробуйте снова.',
    'Model service is not reachable. Try again.': 'Сервис моделей недоступен. Попробуйте снова.',
    'The model is not deployed.': 'Модель не развёрнута.',
    'The model failed on this drawing. Try again.': 'Модель не справилась с этим чертежом. Попробуйте снова.',
    'Could not process this drawing. Try again.': 'Не удалось обработать чертёж. Попробуйте снова.',

    // import modals
    'Import from local storage {id}': 'Импорт из локального хранилища {id}',
    'Import from cloud storage {id}': 'Импорт из облачного хранилища {id}',
    'The file is required': 'Выберите файл',
    'Please select a format first': 'Сначала выберите формат',
    'For {format} format only files with {ext} extension can be used':
        'Для формата {format} подходят только файлы {ext}',
    'Click or drag file to this area': 'Нажмите или перетащите файл сюда',
    'Import format': 'Формат',
    'Select annotation format': 'Выберите формат разметки',
    'File name': 'Имя файла',
    'Dataset file name': 'Имя файла датасета',
    'Backup file name': 'Имя файла резервной копии',
    'Dataset import started': 'Импорт датасета запущен',
    'Annotation import started': 'Импорт разметки запущен',
    'Reference import started': 'Загрузка изображений запущена',
    'Dataset import was started for {target}.': 'Импорт запущен: {target}.',
    'Annotation import was started for {target}.': 'Импорт запущен: {target}.',
    'Reference import was started for {target}.': 'Загрузка запущена: {target}.',
    'Current annotation will be lost': 'Текущая разметка будет заменена',
    'You are going to upload new annotations to {target}. Continue?':
        'Новая разметка заменит текущую: {target}. Продолжить?',
    Update: 'Заменить',
    'Import dataset to {target}': 'Импорт датасета: {target}',
    'Import annotation to {target}': 'Импорт разметки: {target}',
    'Import reference to {target}': 'Добавить изображения: {target}',
    'Labels will be imported from dataset': 'Метки будут взяты из датасета',
    'Labels from project will be used': 'Будут использованы метки проекта',
    'The option is relevant for formats that work with masks only': 'Имеет смысл только для форматов с масками',
    'Importing a dataset for the project #{id}': 'Импорт датасета в проект №{id}',
    'The dataset is being uploaded to the server': 'Датасет загружается на сервер',
    'Dataset import has been started...': 'Импорт датасета начался…',
    'Task from dataset is being created...': 'Создаётся задача из датасета…',
    'No backup file specified': 'Не выбран файл резервной копии',
    'The project creating from the backup has been started': 'Восстановление проекта из резервной копии запущено',
    'The task creating from the backup has been started': 'Восстановление задачи из резервной копии запущено',
    'The reference creating from the backup has been started': 'Восстановление референса из резервной копии запущено',
    'Create project from backup': 'Восстановить проект из резервной копии',
    'Create task from backup': 'Восстановить задачу из резервной копии',
    'Create reference from backup': 'Восстановить референс из резервной копии',
    'Specify source storage with backup': 'Хранилище, где лежит резервная копия',
};
